import { Component, Input, ViewChild } from '@angular/core';
import { HistoryConfigStatus } from '../../context-discovery-services/enums/history-config-status';

@Component({
  selector: 'adminapp-history-config',
  templateUrl: './history-config.component.html',
  styleUrls: ['./history-config.component.scss']
})
export class HistoryConfigComponent {

  _historyConfigParams: any;
  pointsWithHistoryMissing: Array<String> = [];
  status: HistoryConfigStatus;
  actionButtonText: string;
  @ViewChild('pointsGrid') pointsGrid: any;

  @Input()
  isLoading = false;

  @Input()
  set historyConfigParams(historyConfigParams: any) {
    if (JSON.stringify(this._historyConfigParams) !== JSON.stringify(historyConfigParams)) {
      this._historyConfigParams = historyConfigParams;

      if (historyConfigParams.hasOwnProperty('status')) {
        this.status = historyConfigParams.status;
      } else {
        this.status = undefined;
      }
      if (historyConfigParams.hasOwnProperty('nextActionButtonText') && historyConfigParams.nextActionButtonText) {
        this.actionButtonText = historyConfigParams.nextActionButtonText;
      } else {
        this.actionButtonText = undefined;
      }

      if (historyConfigParams.hasOwnProperty('pointsWithMissingHistory') && historyConfigParams.pointsWithMissingHistory) {
        this.pointsWithHistoryMissing = historyConfigParams.pointsWithMissingHistory;
      } else {
        this.pointsWithHistoryMissing = [];
      }
      this.setupPointGrid();
    }
  }

  constructor() { }

  private setupPointGrid() {
    if (this.pointsGrid) {
      this.pointsGrid.nativeElement.columns = [
        { id: 'pointName', label: this.pointsWithHistoryMissing.length + ' Point(s)', isSortable: true }];
      this.pointsGrid.nativeElement.items = this.pointsWithHistoryMissing.map(point => ({ pointName: point }));
    }
  }

  isValidationCompletedSuccessfullyIncludingPointRetrieval() {
    return (this.status === HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_COMPLETED);
  }

  isAnyErrorOccurred() {
    if (this.isPointsWithMissingHistoryFailedToRetrieve()) {
      return true;
    }
    switch (this.status) {
      case HistoryConfigStatus.VALIDATION_COMPLETED_WITH_ERRORS:
      case HistoryConfigStatus.MODEL_UPDATE_FAILED:
      case HistoryConfigStatus.ERROR:
        return true;
    }
    return false;
  }

  isPointsWithMissingHistoryFailedToRetrieve() {
    return (this.status === HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_FAILED);
  }

  isBlobUploaded() {
    return (this.status === HistoryConfigStatus.BLOB_UPLOADED);
  }

  isHistoryUploadDataNotAvailable() {
    return (this.status === HistoryConfigStatus.NOT_AVAILABLE);
  }

  isPointsWithMissingHistoryPresent() {
    return (this.pointsWithHistoryMissing && this.pointsWithHistoryMissing.length > 0);
  }
}
